import { getAccountOrgMembershipRequestParamsSchema, getAccountOrgMembershipResponseSchema } from './types';
export const getAccountOrgMembershipDef = {
    name: 'getAccountOrgMembership',
    requestSchema: getAccountOrgMembershipRequestParamsSchema,
    responseSchema: getAccountOrgMembershipResponseSchema,
};
